var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { staticClass: "assets-by-group-table-row text-xs text-color-800" },
    [
      _vm._l(_vm.columns, function(col) {
        return [
          col.cellType === "text" && _vm.isVisible(col.key)
            ? _c(
                "td",
                {
                  key: "cell-" + col.key,
                  staticClass: "assets-by-group-table-row__column",
                  class:
                    col.align === "left"
                      ? "text-left"
                      : col.align === "right"
                      ? "text-right"
                      : ""
                },
                [
                  col.align === "left"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "assets-by-group-table-row__column--text-ellipsis text-truncate"
                        },
                        [_vm._v(" " + _vm._s(col.value(_vm.asset)) + " ")]
                      )
                    : col.cellClass
                    ? _c("span", { class: col.cellClass }, [
                        _vm._v(_vm._s(col.value(_vm.asset)))
                      ])
                    : [_vm._v(_vm._s(col.value(_vm.asset)))]
                ],
                2
              )
            : col.key === "ativo" && _vm.isVisible("ativo")
            ? _c(
                "td",
                {
                  key: "ativo-" + col.key,
                  staticClass: "assets-by-group-table-row__column"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "assets-by-group-table-row__column--checkbox d-flex align-items-center az-gap-small"
                    },
                    [
                      !_vm.readonly
                        ? _c("v-checkbox", {
                            staticClass: "p-0 m-0",
                            attrs: {
                              value: _vm.asset.id,
                              dense: "",
                              "hide-details": "",
                              ripple: false,
                              color: "primary"
                            },
                            model: {
                              value: _vm.selectedAssetsInside,
                              callback: function($$v) {
                                _vm.selectedAssetsInside = $$v
                              },
                              expression: "selectedAssetsInside"
                            }
                          })
                        : _vm._e(),
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center az-gap-xsmall"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "assets-by-group-table-row__name d-flex align-items-center az-gap-xsmall"
                              },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "span",
                                                _vm._g({}, on),
                                                [
                                                  !_vm.readonly
                                                    ? _c(
                                                        "v-edit-dialog",
                                                        {
                                                          attrs: {
                                                            "return-value":
                                                              _vm.insideAssetName,
                                                            large: "",
                                                            "cancel-text":
                                                              "Cancelar",
                                                            "save-text":
                                                              "Salvar",
                                                            persistent: ""
                                                          },
                                                          on: {
                                                            "update:returnValue": function(
                                                              $event
                                                            ) {
                                                              _vm.insideAssetName = $event
                                                            },
                                                            "update:return-value": function(
                                                              $event
                                                            ) {
                                                              _vm.insideAssetName = $event
                                                            },
                                                            save:
                                                              _vm.handleSaveName,
                                                            open:
                                                              _vm.handleOpenName,
                                                            close:
                                                              _vm.handleCloseName
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "input",
                                                                fn: function() {
                                                                  return [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Nome do ativo",
                                                                          "single-line":
                                                                            ""
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.insideAssetName,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.insideAssetName = $$v
                                                                          },
                                                                          expression:
                                                                            "insideAssetName"
                                                                        }
                                                                      }
                                                                    )
                                                                  ]
                                                                },
                                                                proxy: true
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.asset
                                                                  .nome_ativo ||
                                                                  "—"
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    : [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.asset
                                                                .nome_ativo ||
                                                                "—"
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                ],
                                                2
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.asset.nome_ativo || "—") +
                                          " "
                                      )
                                    ])
                                  ]
                                ),
                                _vm.asset.loadingEdit
                                  ? _c("v-progress-circular", {
                                      attrs: {
                                        indeterminate: "",
                                        size: "16",
                                        color: "primary"
                                      }
                                    })
                                  : _vm._e(),
                                !_vm.$currentUser().IS_CLIENTE &&
                                _vm.suitability &&
                                _vm.suitability.isOutOfMargin
                                  ? [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      "span",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "d-inline-flex ml-1"
                                                          },
                                                          "span",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c("icon-svg", {
                                                          attrs: {
                                                            name:
                                                              "warning-status",
                                                            color: "#E0AF00",
                                                            size: "16"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " Desvio: " +
                                                _vm._s(
                                                  (
                                                    _vm.suitability.deviation *
                                                    100
                                                  ).toFixed(1)
                                                ) +
                                                "% (margem: " +
                                                _vm._s(
                                                  (
                                                    _vm.suitability.margin * 100
                                                  ).toFixed(1)
                                                ) +
                                                "%) "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm.mostraSugestoes
                              ? _c("IaSuggestionsPendingBadge", {
                                  attrs: { pendentes: _vm.sugestoesPendentes },
                                  on: { revisar: _vm.handleRevisarSugestoes }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c("AssetTags", {
                              staticClass: "assets-by-group-table-row__info",
                              attrs: {
                                asset: _vm.asset,
                                "asset-view": _vm.assetView,
                                "composicao-fundos": _vm.composicaoFundos,
                                readonly: _vm.readonly
                              },
                              on: {
                                "open-detalhes": _vm.handleOpenDetalhes,
                                "open-new-asset": _vm.handleOpenNewAsset
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ]
              )
            : col.key === "instituicao" && _vm.isVisible("instituicao")
            ? _c(
                "td",
                {
                  key: "inst-" + col.key,
                  staticClass: "assets-by-group-table-row__column text-left"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "assets-by-group-table-row__column--text-ellipsis text-truncate"
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c("span", _vm._g({}, on), [
                                      _vm._v(
                                        " " + _vm._s(_vm.corretoraText) + " "
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.corretoraText))])]
                      )
                    ],
                    1
                  )
                ]
              )
            : col.key === "saldo_valor" && _vm.isVisible("saldo_valor")
            ? _c(
                "td",
                {
                  key: "svalor-" + col.key,
                  staticClass: "assets-by-group-table-row__column text-right"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "assets-by-group-table-row__saldo",
                      class: _vm.saldoClass
                    },
                    [_vm._v(" " + _vm._s(_vm.assetAplicacaoText) + " ")]
                  )
                ]
              )
            : col.key === "saldo_pct" && _vm.isVisible("saldo_pct")
            ? _c(
                "td",
                {
                  key: "spct-" + col.key,
                  staticClass: "assets-by-group-table-row__column text-right"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "assets-by-group-table-row__pct-total",
                      class: _vm.saldoClass
                    },
                    [_vm._v(" " + _vm._s(_vm.assetPctText) + " ")]
                  )
                ]
              )
            : col.key === "saldo_data" && _vm.isVisible("saldo_data")
            ? _c(
                "td",
                {
                  key: "sdata-" + col.key,
                  staticClass: "assets-by-group-table-row__column"
                },
                [
                  _vm.asset.data_referencia_pl
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "min-width": "20px",
                            "white-space": "nowrap"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.asset._d_referencia_pl || "-") +
                              " "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            : col.key === "rent_valor"
            ? [
                _vm.showRentability && _vm.hasNoRent && _vm.rentColspan > 0
                  ? _c("td", {
                      key: col.key + "-no-rent",
                      staticClass: "assets-by-group-table-row__column",
                      attrs: { colspan: _vm.rentColspan }
                    })
                  : _vm._e(),
                _vm.showRentability && _vm.hasAlert && _vm.rentColspan > 0
                  ? _c(
                      "td",
                      {
                        key: col.key + "-alert",
                        staticClass: "assets-by-group-table-row__column",
                        attrs: { colspan: _vm.rentColspan }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass:
                              "assets-by-group-table-row__button assets-by-group-table-row__button--fill bg-danger text-danger",
                            staticStyle: { "font-size": "10px" },
                            attrs: {
                              text: "",
                              small: "",
                              disabled: !_vm.podeAbrirDetalhes
                            },
                            on: { click: _vm.handleOpenDetalhes }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.podeAbrirDetalhes
                                    ? "Preencher movimentações"
                                    : "Movimentações pendentes"
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showRentability && _vm.hasMissing && _vm.rentColspan > 0
                  ? _c(
                      "td",
                      {
                        key: col.key + "-missing",
                        staticClass: "assets-by-group-table-row__column",
                        attrs: { colspan: _vm.rentColspan }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass:
                              "assets-by-group-table-row__button assets-by-group-table-row__button--missing bg-danger text-danger",
                            staticStyle: { "font-size": "10px" },
                            attrs: {
                              text: "",
                              small: "",
                              disabled: !_vm.podeAbrirDetalhes
                            },
                            on: { click: _vm.handleOpenDetalhes }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.podeAbrirDetalhes
                                    ? "Inserir informações faltantes"
                                    : "Informações faltantes"
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showRentability && _vm.hasRentCols
                  ? [
                      _vm.isVisible("rent_valor")
                        ? _c(
                            "td",
                            {
                              key: "rvalor-" + col.key,
                              staticClass:
                                "assets-by-group-table-row__column text-right"
                            },
                            [
                              _vm.hasStats
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "assets-by-group-table-row__rent",
                                      class: _vm.rendimentoClass
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.assetRendText) + " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm.isVisible("rent_inicio")
                        ? _c(
                            "td",
                            {
                              key: col.key + "-inicio",
                              staticClass:
                                "assets-by-group-table-row__column text-right"
                            },
                            [
                              _vm.hasStats
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "assets-by-group-table-row__start",
                                      class: _vm.inicioClass
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.assetStatsFmt.inicioFmt) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm.isVisible("rent_data")
                        ? _c(
                            "td",
                            {
                              key: col.key + "-data",
                              staticClass: "assets-by-group-table-row__column"
                            },
                            [
                              _vm.asset.data_referencia_cotizacao
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "min-width": "20px",
                                        "white-space": "nowrap"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.asset._d_referencia_cotizacao ||
                                              "-"
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  : _vm._e()
              ]
            : col.key === "volatilidade" && _vm.isVisible("volatilidade")
            ? _c(
                "td",
                {
                  key: "vol-" + col.key,
                  staticClass: "assets-by-group-table-row__column text-right"
                },
                [
                  _vm.hasStats
                    ? _c(
                        "div",
                        { staticClass: "assets-by-group-table-row__vol" },
                        [_vm._v(" " + _vm._s(_vm.assetStatsFmt.volFmt) + " ")]
                      )
                    : _vm._e()
                ]
              )
            : col.key === "recomendacao" && _vm.isVisible("recomendacao")
            ? _c(
                "td",
                {
                  key: "rec-" + col.key,
                  staticClass: "assets-by-group-table-row__column"
                },
                [
                  _vm.asset.recomendacao
                    ? _c("BaseStatus", {
                        attrs: {
                          soft: "",
                          content: _vm.recomendacaoLabel,
                          color: _vm.recomendacaoStatusColor
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : col.key === "comentario" && _vm.isVisible("comentario")
            ? _c(
                "td",
                {
                  key: "com-" + col.key,
                  staticClass: "assets-by-group-table-row__column"
                },
                [
                  _vm.asset.comentario
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        {
                                          attrs: { small: "", color: "primary" }
                                        },
                                        on
                                      ),
                                      [_vm._v(" mdi-comment-text ")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.asset.comentario))])]
                      )
                    : _c("v-icon", { attrs: { small: "", color: "grey" } }, [
                        _vm._v(" mdi-comment-outline ")
                      ])
                ],
                1
              )
            : col.key === "acoes" && _vm.showAcoes
            ? _c(
                "td",
                {
                  key: "acoes-" + col.key,
                  staticClass: "assets-by-group-table-row__column"
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      { attrs: { id: "item-menu-" + _vm.asset.id } },
                      [
                        _c("TableRowActions", {
                          attrs: { actions: _vm.rowActions, "inline-limit": 0 }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }